import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { PlanResource, planResourceSchema } from "./resources/PlanResource";
import { array, object } from "yup";

const fetchPlansResponseSchema = object({
  data: array().of(planResourceSchema).required(),
});

export const fetchPlans = async (): Promise<ApiResponse<PlanResource[]>> => {
  const response = await fetchData("/dietitian/plans", APIMethods.GET);

  return await fetchPlansResponseSchema.validate(response);
};
